import { isSameDay, OwaDate } from 'owa-datetime';
import DateSelectorMode, {
    SINGLE_LINE_SAME_DAY,
    MULTILINE_WITH_TIME,
    SINGLE_LINE_DURATION,
    MULTILINE_DURATION,
    MULTILINE_WITH_TIMEZONES,
    MULTILINE,
} from '../types/DateSelectorMode';
import getDurationInDays from './getDurationInDays';
import { DurationDayLength } from '../components/DurationDropdown';

export default function getInitialSelectorMode(
    isNarrow: boolean,
    isAllDay: boolean,
    start: OwaDate,
    end: OwaDate,
    showTimeZones: boolean
): DateSelectorMode {
    let initialSelectorMode: DateSelectorMode;
    let durationInDays = getDurationInDays(start, end);

    if (isNarrow) {
        if (isAllDay) {
            if (durationInDays == DurationDayLength.One) {
                initialSelectorMode = SINGLE_LINE_DURATION;
            } else if (durationInDays >= DurationDayLength.Custom) {
                initialSelectorMode = MULTILINE;
            } else {
                initialSelectorMode = MULTILINE_DURATION;
            }
        } else {
            initialSelectorMode = MULTILINE_WITH_TIME;
        }
    } else {
        if (isAllDay) {
            if (durationInDays == DurationDayLength.One) {
                initialSelectorMode = SINGLE_LINE_DURATION;
            } else if (durationInDays >= DurationDayLength.Custom) {
                initialSelectorMode = MULTILINE;
            } else {
                initialSelectorMode = MULTILINE_DURATION;
            }
        } else {
            initialSelectorMode = showTimeZones
                ? MULTILINE_WITH_TIMEZONES
                : isSameDay(start, end)
                ? SINGLE_LINE_SAME_DAY
                : MULTILINE_WITH_TIME;
        }
    }

    return initialSelectorMode;
}
